// extracted by mini-css-extract-plugin
export default {"title":"VwzDlSlf_1AOCwQZjHVb","box":"kMZM8YpUX43zSJQzvx2v","value":"cmgA0VNvSHQyn5mMFgOw","icon":"fJQPkrFvV38EmogQRDZL"};